import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { LoggerFactory, Logger } from './../../core/logger.service';
import { SiteSpecific, UserSession } from './../../core/site-specific.base';
import { ClipboardService } from 'ngx-clipboard';
import { AccountService } from 'app/account/account.service';
import { Account } from 'app/back-office/account.model';
import { SnackBarService } from 'app/core/snack-bar.service';
import { TrackerService } from '../services/tracker.service';
import { Environment, ENVIRONMENT_DI } from 'app/environment/environment';

@Component({
  selector: 'app-tracking-code',
  templateUrl: './tracking-code.component.html',
  styleUrls: ['./tracking-code.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TrackingCodeComponent extends SiteSpecific {
  public loading: boolean;
  private readonly logger: Logger;

  public trackingCode = '';

  constructor(
    loggerFactory: LoggerFactory,
    protected readonly session: UserSession,
    private readonly accountService: AccountService,
    private clipboardService: ClipboardService,
    private readonly snackbar: SnackBarService,
    @Inject(ENVIRONMENT_DI) private readonly environment: Environment,
  ) {
    super(session, loggerFactory);
    this.logger = loggerFactory.get('ConsentRegistrationComponent');
  }

  protected async onSiteChanged() {
    const account = await this.accountService.getCurrentAccountAsync();
    this.loading = true;
    this.loadTrackingCode(account);
    this.loading = false;
  }

  public loadTrackingCode(account: Account) {
    if (!account) {
      this.logger.error('There is no current account set');
      return;
    }
    this.trackingCode =
      '<!-- Triggerbee -->\n' +
      '<script type="text/javascript">\n' +
      TrackerService.getTrackingScript(
        account.siteId,
        TrackerService.getTrackerBaseUrl(account, this.environment.trackerDomain),
      ) +
      '</script>' +
      '\n<!-- End Triggerbee -->';
  }

  public copyToClipboard(content: string) {
    this.clipboardService.copyFromContent(content);
    this.snackbar.success('generic.copyToClipboard.copied');
  }

  public copyTrackingCodeToClipboard() {
    this.clipboardService.copyFromContent(this.trackingCode);
    this.snackbar.success('settings.account.code.copied');
  }
}
